import colorConfigs from "../../configs/colorConfigs";

const ForgetPasswordPageStyles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '70vh',
      background:colorConfigs.secondary,
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor:colorConfigs.backgrounds.white,
      borderRadius: '8px',
      padding: '24px',
      boxShadow: colorConfigs.backgrounds.boxshadow,
      width:'90%',

    },
    headerText: {
      color: colorConfigs.primary,
      fontWeight: 500,
    },
    descriptionText: {
      marginTop: '8px',
    },
    phoneInputContainer: {
      mt: 2,
      width: '100%',
    },
    sendOtpButton: {
      mt: 3,
      mb: 2,
      color: colorConfigs.secondary,
      backgroundColor: colorConfigs.primary,
      '&:hover': {
        backgroundColor: colorConfigs.primary,
      },
      borderRadius: '30px',
    },
    loginLink: {
      textDecoration: 'none',
      color: colorConfigs.primary,
    },
  };
  
  export default ForgetPasswordPageStyles;
  